import { css } from "@emotion/react"
import axios from "axios"
import { Field, Button } from "component"
import { API_BASE_URL, TIME_DIFFERENCE } from "config"
import { ChangeEvent, MutableRefObject, useEffect, useRef } from "react"
import { AiOutlineCalendar } from "react-icons/ai"
import { SwipeCallback, useSwipeable } from "react-swipeable"
import { toast } from "react-toastify"
import { ON_TERTIARY_CONTAEINER_COLOR, TERTIARY_CONTAINER_COLOR } from "style"
import { PhotoWithIndex } from "type"

const invisiblePosition = '-400px'
const visiblePosition = '0px'

type Props = {
  isVisible: boolean
  photo: PhotoWithIndex
  onSwipeDown?: SwipeCallback
  onDeleteSuccess?: () => void
}

// TODO add effect to tell if update request is success or failure.
export const SubContainer = (props: Props) => {
  const cardElement = useRef<HTMLDivElement>()

  let newTime = 0

  let bposition = props.isVisible ? visiblePosition : invisiblePosition

  useEffect(() => {
    changePosition(cardElement, bposition)
  }, [bposition])

  const refPassThrough = (el: HTMLDivElement) => {
    cardSwipeHandlers.ref(el)
    cardElement.current = el
  }

  const setNewTime = (evt: ChangeEvent<HTMLInputElement>) => {
    const value = evt.target.value + TIME_DIFFERENCE
    newTime = new Date(value).getTime()
  }


  const cardSwipeHandlers = useSwipeable({
    onSwipedDown: (evt) => {
      if (!props.onSwipeDown) return
      props.onSwipeDown(evt)
    },
    onSwiping: (event) => {
      const newPosition = calcNewStyleFromDelta(bposition, event.deltaY)
      changePosition(cardElement, newPosition)
    },
    onTouchEndOrOnMouseUp: () => {
      if (!cardElement.current) return
      bposition = cardElement.current.style.bottom
    },
    trackMouse: true,
    preventScrollOnSwipe: true
  })

  return (
    <div css={modalCss} {...cardSwipeHandlers} ref={refPassThrough} >
      <div css={markCss} />
      <Field
        level="tertiary"
        type="datetime-local"
        icon={<AiOutlineCalendar />}
        placeholder=""
        onChange={setNewTime}
      />
      <div css={buttonCentralized}>
        <Button onClick={() => updateTime(props.photo.type, props.photo.filename, newTime)} level="tertiary">Update</Button>
      </div>
      <div css={[buttonCentralized, marginCss]}>
        <Button onClick={() => onDeleteClick(props.photo.filename)} level="error">Delete</Button>
      </div>
    </div>

  )
}

const calcNewStyleFromDelta = (style: string, delta: number) => {
  const styleNum: number = parseInt(style.endsWith('px') ? style.slice(0, -2) : style)
  const newPosition = Math.min(0, styleNum - delta)

  return newPosition.toString() + 'px'
}

const changePosition = (ref: MutableRefObject<HTMLDivElement | undefined>, position: string) => {
  if (!ref.current) return
  ref.current.style.bottom = position
}

const updateTime = async (type: string, filename: string, timestamp: number) => {
  const body = {
    type: type,
    filename: filename,
    timestamp: timestamp
  }
  try {
    await axios.put(API_BASE_URL + '/image', body)
    toast.success('Update is successful')
  } catch (e) {
    toast.error('Update is failed')
  }
}

const onDeleteClick = async (filename: string) => {
  try {
    await axios.delete(API_BASE_URL + '/image/' + filename)
    toast.success('Delete is successful')
  } catch (e) {
    toast.error('Delete is failed')
  }
}

const markCss = css`
  background-color: ${ON_TERTIARY_CONTAEINER_COLOR};
  width: 40px;
  height: 3px;
  margin: 5px auto;
`

const modalCss = css`
  background-color: ${TERTIARY_CONTAINER_COLOR};
  color: ${ON_TERTIARY_CONTAEINER_COLOR};
  position: fixed;
  transition-duration: 0.3s;
  width: 100%;
  height: 300px;
  z-index: 9999;
  border-radius: 10px 10px 0px 0px;
  padding: 10px;
`

const buttonCentralized = css`
  margin-top: 10px;
  display: flex;
  justify-content: center;
`

const marginCss = css`
  margin-top: 40px;
`